import FileIcon from '@material-ui/icons/FileCopy';
import FilesEdit from './filesEdit';
import FilesList from './filesList';
import FilesShow from './filesShow';

export default {
  edit: FilesEdit,
  list: FilesList,
  show: FilesShow,
  icon: FileIcon,
};
